import { render, staticRenderFns } from "./BookingDuplicateShortlist.vue?vue&type=template&id=0b70d6ea"
import script from "./BookingDuplicateShortlist.vue?vue&type=script&lang=js"
export * from "./BookingDuplicateShortlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports